
import {throwError as observableThrowError, Subject } from 'rxjs';
import {finalize, catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs';

import { LoginService } from '../../login/shared/login.service';
import { environment } from './../../../environments/environment';

@Injectable()
export class TemplateSetService {
    private refreshSubject = new Subject<any>();

    constructor(
        private http: HttpClient,
        private authenticate: LoginService,
    ) { }


    /* GET METHODS START */
    getTemplateSetList() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/template', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getTemplateListForFilter() {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/individual_employment_setting/temp_name', options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }

    getTemplateDetail(id: string) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/template/'+id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }

    getTemplateUsers(id: string) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.get(environment.SERVER_URL + '/template/stafflist/'+id, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }
    /* GET METHODS END */



    /* POST METHODS START */
    addTemplate(data: any) {
        const headers = new HttpHeaders({ 'Authorization': this.authenticate.getToken(), 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.post(environment.SERVER_URL + '/template', data, options).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }
    /* POST METHODS END */



    /* PUT METHODS START */
    editTemplate(data: any, id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.put(environment.SERVER_URL + '/template/'+id, data, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),);
    }
    /* PUT METHODS END */

    deleteTemplate(id: string) {
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        const options = { headers: headers };

        return this.http.delete(environment.SERVER_URL + '/template/' + id, options ).pipe(
                        map(this.extractData),
                        catchError(this.handleError),
                        finalize(() => {
                            this.refreshSubject.next();
                        }),);
    }



    /* SUBSCRIPTION METHODS START */
    onRefresh() {
        return this.refreshSubject.asObservable();
    }
    /* SUBSCRIPTION METHODS END */



    private extractData(res: any) {
        let body = res;
        return body.data || {};
    }

    private handleError (error: any) {
        let errMsg: string;
        if (error) {
        const body = error || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
        } else {
        errMsg = error.message ? error.message : error.toString();
        }
        console.error(errMsg);
        return observableThrowError(errMsg);
    }
}